import React, { useEffect, useState } from 'react';
import { addDays, addSeconds, isFuture } from 'date-fns';
import { useQuery } from '@apollo/client';
import { useRouteMatch } from 'react-router-dom';

// Components
import StepOne from './StepOne';
import StepTwoBase from './StepTwo';
import { Unlock } from './unlock';
import { Success } from './success';
import useLocalStorage from '../../../hooks/useLocalStorage';
import ProgressiveProfilingForm from './ProgressiveProfilingForm';
import GlobalModal from '@molecules/GlobalModal/index';

// Functionality
import { GlobalModalContext } from '@context/globalModalContext';
import { SAVED_SEARCHES_QUERY } from '@general/graphql/saved-searches.graph';
import useModal from '@hooks/useModal';
import useViewer from '@hooks/useViewer';

const StepTwo = props => <StepTwoBase submitButtonClass="progprofile" {...props} />;

const ProgressiveProfilingModal = () => {
    const { isModalOpen, setIsModalOpen } = useModal();
    const [overlay, setOverlay] = useState(null);
    const [dismissedAt, setDismissedAt] = useLocalStorage('pp_modal_dismissed_at', null);
    const [shouldShowModal, setShouldShowModal] = useState(false);
    const isMyMatchesRoute = useRouteMatch('/my-icsc/connections/my-matches');
    const isEventRegistrationRoute = useRouteMatch('/event-registration/*');
    const isMembershipRoute = useRouteMatch('/membership/*');
    const isCartRoute = useRouteMatch('/cart/*');
    const { viewer } = useViewer();

    useQuery(SAVED_SEARCHES_QUERY, {
        fetchPolicy: 'network-only',
        onCompleted: ({ savedSearches }) => {
            if (
                savedSearches?.length === 0 &&
                !isMyMatchesRoute &&
                !isEventRegistrationRoute &&
                !isMembershipRoute &&
                !isCartRoute
            ) {
                return setShouldShowModal(true);
            }
        },
    });

    const closeForm = () => {
        setDismissedAt(Date.now());
        setIsModalOpen(false);
    };

    useEffect(() => {
        if (!viewer) {
            return;
        }

        const ttl =
            dismissedAt && window.isStaging === true
                ? addSeconds(new Date(dismissedAt), 5)
                : addDays(new Date(dismissedAt), 10);

        const hasDimissedRecently = ttl ? isFuture(ttl) : false;

        if (!isModalOpen && !hasDimissedRecently && shouldShowModal) {
            const timer = setTimeout(() => setIsModalOpen(true), 5000);
            return () => clearTimeout(timer);
        }
    }, [viewer, dismissedAt, isModalOpen, setIsModalOpen, shouldShowModal]);

    const onNext = () => {
        if (overlay) {
            overlay.scrollTo(0, 0);
        }
    };

    return (
        <GlobalModalContext.Provider value={[isModalOpen, setIsModalOpen]}>
            <GlobalModal
                modalOuterClass="progressive-profile-modal"
                onClose={() => setDismissedAt(Date.now())}
                setOverlayRef={overlayRef => setOverlay(overlayRef)}
            >
                <ProgressiveProfilingForm
                    onNext={onNext}
                    onComplete={closeForm}
                    unlock={Unlock}
                    steps={[StepOne, StepTwo]}
                    success={Success}
                    saveAsDefault
                />
            </GlobalModal>
        </GlobalModalContext.Provider>
    );
};

export default ProgressiveProfilingModal;
